export enum EDevicesPerm {
    DEVICES_API_KEY = 'devices_api_key',
    DEVICES_EDIT_SERIAL = 'devices_edit_serial',
    DEVICES_FIRMWARE_UPDATE = 'devices_firmware_update'
}
